mutation DeleteScene($eventId: ID!, $overlayId: ID!, $sceneId: ID!) {
  result: StreamToolsDeleteScene(eventId: $eventId, overlayId: $overlayId, sceneId: $sceneId) {
    id
    deleted
  }
}
